import { uomActionTypes } from '@Actions/uomActions';

const UomReducer = (state = { }, action) => {
  switch (action.type) {
  case uomActionTypes.CREATE_UOM.LOADING: {
    const { createUomLoading } = action;
    return {
      ...state,
      createUomLoading,
    };
  }
  case uomActionTypes.GET_UOMS.LOADING: {
    const { getUomsLoading } = action;
    return {
      ...state,
      getUomsLoading,
    };
  }
  case uomActionTypes.GET_UOMS.SUCCESS: {
    const { uoms } = action;
    return {
      ...state,
      uoms,
    };
  }
  case uomActionTypes.UPDATE_UOM.LOADING: {
    const { updateUomLoading } = action;
    return {
      ...state,
      updateUomLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default UomReducer;
